// TODO: Review AI Code for feature: Process Map - Entire file is AI-generated

export type FilterMode = 'highlight' | 'filter';

export interface ProcessMapUIState {
  isFullscreen: boolean;
  isEditorMode: boolean;
  selectedDepartments: string[];
  departmentFilterMode: FilterMode;
  deptSearch: string;
  selectedChains: string[];
  chainFilterMode: FilterMode;
  showResetConfirm: boolean;
  showDiscardConfirm: boolean;
  showKpis: boolean;
  dismissedHint: boolean;
}

export type ProcessMapUIAction =
  | { type: 'TOGGLE_FULLSCREEN' }
  | { type: 'SET_FULLSCREEN'; value: boolean }
  | { type: 'SET_EDITOR_MODE'; value: boolean }
  | { type: 'SET_SELECTED_DEPARTMENTS'; value: string[] }
  | { type: 'TOGGLE_DEPARTMENT_FILTER_MODE' }
  | { type: 'SET_DEPT_SEARCH'; value: string }
  | { type: 'SET_SELECTED_CHAINS'; value: string[] }
  | { type: 'TOGGLE_CHAIN_FILTER_MODE' }
  | { type: 'SET_SHOW_RESET_CONFIRM'; value: boolean }
  | { type: 'SET_SHOW_DISCARD_CONFIRM'; value: boolean }
  | { type: 'TOGGLE_KPIS' }
  | { type: 'DISMISS_HINT' }
  | { type: 'DISCARD_CONFIRMED' };

export const initialUIState: ProcessMapUIState = {
  isFullscreen: false,
  isEditorMode: false,
  selectedDepartments: [],
  departmentFilterMode: 'highlight',
  deptSearch: '',
  selectedChains: [],
  chainFilterMode: 'highlight',
  showResetConfirm: false,
  showDiscardConfirm: false,
  showKpis: false,
  dismissedHint: false
};

export function processMapUIReducer(
  state: ProcessMapUIState,
  action: ProcessMapUIAction
): ProcessMapUIState {
  switch (action.type) {
    case 'TOGGLE_FULLSCREEN':
      return { ...state, isFullscreen: !state.isFullscreen };
    case 'SET_FULLSCREEN':
      return { ...state, isFullscreen: action.value };
    case 'SET_EDITOR_MODE':
      return { ...state, isEditorMode: action.value };
    case 'SET_SELECTED_DEPARTMENTS':
      return { ...state, selectedDepartments: action.value };
    case 'TOGGLE_DEPARTMENT_FILTER_MODE':
      return {
        ...state,
        departmentFilterMode: state.departmentFilterMode === 'highlight' ? 'filter' : 'highlight'
      };
    case 'SET_DEPT_SEARCH':
      return { ...state, deptSearch: action.value };
    case 'SET_SELECTED_CHAINS':
      return { ...state, selectedChains: action.value };
    case 'TOGGLE_CHAIN_FILTER_MODE':
      return {
        ...state,
        chainFilterMode: state.chainFilterMode === 'highlight' ? 'filter' : 'highlight'
      };
    case 'SET_SHOW_RESET_CONFIRM':
      return { ...state, showResetConfirm: action.value };
    case 'SET_SHOW_DISCARD_CONFIRM':
      return { ...state, showDiscardConfirm: action.value };
    case 'TOGGLE_KPIS':
      return { ...state, showKpis: !state.showKpis };
    case 'DISMISS_HINT':
      return { ...state, dismissedHint: true };
    case 'DISCARD_CONFIRMED':
      return { ...state, isEditorMode: false, showDiscardConfirm: false };
  }
}
